import './z_header';
import '../css/z_category.less';
import pagination from '../../libs/pagination/pagination';
import banner from '../../libs/banner/banner';
import '../css/list.less';

// banner
if($('body').width()<768){
    banner.render({ bannerScale: 4/3 });
}else{
    banner.render({ bannerWidth: 1920, bannerHeight: 650 });
}

pagination.render({
    limit: 12,
});

// 加载更多
$(function () {
    $(document).on("click", ".mu8-loadmore-list", function () {
        var that = this;
        var page = parseInt($(this).data("page"));
        page++;
        $(that).prop("disabled", true);
        $.ajax({
            url: location.pathname + $(that).data("href"),
            type: "post",
            success: function (res) {
                console.log(res.data);
                $('.mu8-main-content').append(res.data);
                $(that).parent().remove();
                return false;
            },
        });
        return false;
    })
});